import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { SystemPropertiesService } from '@app/core/services/system-properties.service';
import { IPortfolioCompany } from '@common/models/IPortfolioCompany';
import { ConfirmationService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { CompanyService } from '../../../modules/companies/services/company.service';
import { SystemPropertyKey } from '@common/enums/SystemPropertyKey';
import { APP_CONSTANTS } from '@app/services/common/app-constants';
import { sharePointURL } from '@app/services/common/utils';

@Component({
  selector: 'app-company-header',
  templateUrl: './company-header.component.html',
  styleUrls: ['./company-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompanyHeaderComponent implements OnInit,OnChanges  {

  @Input () company: IPortfolioCompany;
  @Output() logoChanged = new EventEmitter<string>();
  infoMsg: string ='Click to edit PC Master list, contacts';
  listName : string;
  url: string;
  logoAttachmentTypes:string;
  imageUrl: string = '';

  constructor(private readonly systemPropertiesService: SystemPropertiesService,
    private readonly confirmationService: ConfirmationService,
    private readonly companyService:CompanyService) { }

  ngOnInit(): void {
    this.systemPropertiesService.getByKey<string>(SystemPropertyKey.portfolioCompanyMasterList).subscribe((res) => {
      this.listName = res;
    });
    this.systemPropertiesService.getByKey<string[]>(SystemPropertyKey.logoAttachmentTypes, ["png", "jpg", "jpeg"]).subscribe((res:any) => {
      this.logoAttachmentTypes = res.map((type) => '.' + type).join(',');
    });
    this.setImageUrl();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.company?.currentValue) {
      this.setImageUrl();
    }
  }

  setImageUrl() {
    if (this.company?.image) {
      const timestamp = new Date().getTime(); // prevent caching
      this.imageUrl = `${this.imageLocation}/${this.company.mnemonic}/${this.company.image}?t=${timestamp}`;
    }
  }

  get imageLocation(): string {
    return environment.companyImageLocation;
  }

  editList(){
    // Calculate url at last minute, so all properties are available
    this.url = sharePointURL(this.listName, APP_CONSTANTS.SHAREPOINT_VIEW_ID.PortfolioCompanyQuiltDev, this.company?.mnemonic);
    window.open(this.url);
  }
  hideImage(event: Event) {
    const img = event.target as HTMLImageElement;
    img.style.visibility = 'hidden';
  }

  onLogoUpload(event: Event) {
    if ((this.company.image || '') !== '') {
      this.confirmationService.confirm({
        message: `This will replace existing document ${this.company.image}. Are you sure that you want to proceed?`,
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.uploadLogo(event)
        },
        reject: () => {}
      })
    } else {
      this.uploadLogo(event)
    }

  }

  uploadLogo(event) {
    let formData = new FormData();
    formData.append("uploads[]", event.target.files[0], event.target.files[0].name);
    this.companyService.uploadLogo(this.company.mnemonic, formData).subscribe({
      next: (value: any) => {
        this.setImageUrl();
        this.logoChanged.emit(value);
      }, error: (err) => {
        this.logoChanged.emit(err);
      }
    })

}
}